import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import * as styles from "./overviewFooterStyles";

const Footer: React.FC = () => {
    return (
        <Box sx={styles.footerContentStyles}>
            <Box
                component="img"
                sx={styles.footerLogoStyles}
                alt="Sturm und Glanz Logo"
                src="/images/illustrations/s_g_gold.png"
            />

            <Box>
                <Box sx={styles.footerLinksContainer}>
                    <Link
                        component={RouterLink}
                        to="/impressum"
                        sx={styles.footerLink}
                    >
                        Impressum
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/datenschutz"
                        sx={styles.footerLink}
                    >
                        Datenschutz
                    </Link>
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;
